// Canonical default backend base URL — the single source of truth for the
// upstream host when no platform env var overrides it.
//
// Consumed by:
//   - config/upstream.js         → the Netlify edge proxy (runtime, Deno).
//   - vite.config.js             → the dev-server proxy target (`npm run dev`).
//
// Override per environment WITHOUT editing this file:
//   - Local:   VITE_UPSTREAM_URL in .env.local (gitignored).
//   - Netlify: Site settings → Environment variables, scoped per deploy context.
//
// Plain ESM so it can be imported from both Node (Vite config) and Deno (edge).
export const DEFAULT_UPSTREAM_URL = "https://coverxpro.com/ins";

// Canonical default for the Weborder API prefix — the base path the client
// prepends to every Weborder API call. Baked into the bundle by config.js.
// Override per environment WITHOUT editing this file, via VITE_WEBORDER_API_PREFIX
// (.env.local locally; Netlify env per deploy context).
export const DEFAULT_WEBORDER_API_PREFIX = "/api/weborder/v1";

// Canonical default speciality (SP) code used to bootstrap speciality data.
// Override via VITE_DEFAULT_SPECIALITY_CODE (.env.local / Netlify env).
export const DEFAULT_SPECIALITY_CODE = "SP_203";
